import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = `https://p9yvypyh68.execute-api.eu-west-1.amazonaws.com/dev`

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      headers.set('Authorization', token)
    }
    return headers
  },
})

export const apiSlice = createApi({
  reducerPath: 'ApiService',
  tagTypes: [
    'Roles',
    'Users',
    'Mappings',
    'Applications'
  ],
  baseQuery: baseQuery,
  endpoints: () => ({}),
})
